import plData from './pl/index.js'
import {includeCoreLang} from "../core/utils/translationUtil";

export default includeCoreLang({
    'pl': plData,
    'en': plData
})